import * as msal from "@azure/msal-browser";
import router from "@/router";

const state = {
  msalConfig: {
    auth: {
      clientId: process.env.VUE_APP_FIREFLY_AZURE_CLIENT_ID,
      authority: process.env.VUE_APP_FIREFLY_AZURE_AUTHORITY_URL + process.env.VUE_APP_FIREFLY_AZURE_TENANT_ID,
      redirectUri: process.env.VUE_APP_FIREFLY_AZURE_REDIRECT_URL,
    },
  },
  accessToken: "",
  msalInstance: null,
};
const actions = {
  initializeMsalInstance({ commit, state }) {
    if (!state.msalInstance) {
      const instance = new msal.PublicClientApplication(state.msalConfig);
      commit("msalInstanceInitializeSuccessHandler", instance);
      return instance
        .initialize()
        .then(() => {
          console.log("MSAL instance initialized successfully.");
        })
        .catch((error) => {
          commit("msalInstanceInitializeErrorHandler", error);
        });
    }
  },
  async signIn({ commit, state, dispatch }) {
    try {
      if (!state.msalInstance) {
        await dispatch("initializeMsalInstance");
      }
      const loginResponse = await state.msalInstance.loginPopup({
        scopes: ["api://40306a83-ec51-4935-b95e-485d3804873c/read"],
      });
      const tokenResponse = await state.msalInstance.acquireTokenSilent({
        scopes: ["api://40306a83-ec51-4935-b95e-485d3804873c/read"],
        account: state.msalInstance.getAllAccounts()[0],
        forceRefresh: true,
      });
      console.log("tokenResponse", tokenResponse);
      if (tokenResponse && tokenResponse.accessToken) {
        commit("signInSuccessHandler", tokenResponse.accessToken);
      }
      if (tokenResponse && tokenResponse.expiresOn) {
        sessionStorage.setItem("expiresOn", tokenResponse.expiresOn);
        dispatch("setTokenRefreshTimer", tokenResponse.expiresOn);
      }
      if (tokenResponse && tokenResponse.idTokenClaims['groups']) {
        const groups = tokenResponse.idTokenClaims['groups'];
        if (groups.includes(process.env.VUE_APP_FIREFLY_GROUP_ID)) {
          sessionStorage.setItem("isAdmin", true);
        } else {
          sessionStorage.setItem("isAdmin", false);
        }
      }
    } catch (error) {
      if (error instanceof msal.InteractionRequiredAuthError) {
        try {
          const tokenResponse = await state.msalInstance.acquireTokenPopup({
            scopes: ["api://40306a83-ec51-4935-b95e-485d3804873c/read"],
          });
          if (tokenResponse) {
            dispatch("setTokenRefreshTimer", tokenResponse.expiresOn);
            commit("signInSuccessHandler", tokenResponse.accessToken);
          }
        } catch (popupError) {
          commit("signInErrorHandler", popupError);
        }
      }
    }
  },
  setTokenRefreshTimer({ state, dispatch }, expiryTime) {
    const now = Math.floor(Date.now() / 1000);
    const margin = 120;
    const exp = Math.floor(expiryTime.getTime() / 1000);
    const delayInSeconds = exp - now - margin;
    if (delayInSeconds > 0) {
      setTimeout(() => {
        dispatch("refreshAccessToken");
      }, delayInSeconds * 1000);
    }
  },
  async refreshAccessToken({ commit, dispatch, state }) {
    if (!state.msalInstance) {
      await dispatch("initializeMsalInstance");
    }
    try {
      const tokenResponse = await state.msalInstance.acquireTokenSilent({
        scopes: ["api://40306a83-ec51-4935-b95e-485d3804873c/read"],
        account: state.msalInstance.getAllAccounts()[0],
        forceRefresh: true,
      });
      if (tokenResponse && tokenResponse.accessToken) {
        commit("signInSuccessHandler", tokenResponse.accessToken);
      }
      if (tokenResponse && tokenResponse.expiresOn) {
        sessionStorage.setItem("expiresOn", tokenResponse.expiresOn);
        dispatch("setTokenRefreshTimer", tokenResponse.expiresOn);
      }
    } catch (error) {
      console.error("Error refreshing token:", error);
    }
  },
  reinitializeToken({ state, dispatch }) {
    const token = sessionStorage.getItem("accessToken");
    const expiresOn = sessionStorage.getItem("expiresOn");
    if (token && expiresOn) {
      const expiryTime = new Date(expiresOn);
      dispatch("setTokenRefreshTimer", expiryTime);
    }
  },
  checkAndRefreshTokenIfNeeded({ state, dispatch }) {
    console.log("checkAndRefreshTokenIfNeeded triggered");
    const expiresOn = sessionStorage.getItem("expiresOn");
    if (expiresOn) {
      const expiryTime = new Date(expiresOn);
      const now = new Date();
      const margin = 2 * 60 * 1000;
      if (expiryTime.getTime() - now.getTime() < margin) {
        console.log("Access token is near expiry. Refreshing...");
        dispatch("refreshAccessToken");
      }
    }
  },
  async signOut({ commit, state, dispatch }) {
    await dispatch("initializeMsalInstance");
    if (state.msalInstance) {
      const account = JSON.parse(sessionStorage.getItem("userAccount"));
      if (account) {
        state.msalInstance.logoutRedirect({ account })
      }
    }
  }
};
const mutations = {
  signInSuccessHandler(state, token) {
    state.accessToken = token;
    sessionStorage.setItem("accessToken", token);
    const account = state.msalInstance.getAllAccounts()[0];
    sessionStorage.setItem("userAccount", JSON.stringify(account));
  },
  signInErrorHandler(error) {
    console.error(error);
  },
  msalInstanceInitializeSuccessHandler(state, instance) {
    state.msalInstance = instance;
  },
  msalInstanceInitializeErrorHandler(error) {
    console.error(error);
  },
};
const getters = {
  isLoggedIn: (state) => {
    return !!state.accessToken || !!sessionStorage.getItem('accessToken') || !!localStorage.getItem('accessToken');
  },
};
export const authStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
